<div
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  data-test-id="wrap-phone-number"
  *ngIf="selectedCountryPhoneInfo"
>
  <label class="form-label" [for]="fieldAttribute.id" [ngClass]="fieldAttribute.elementStyles.labelStyle">
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
  </label>
  <div class="input-group" data-test-id="wrap-phone-number-countries-list">
    <div class="select-border-div d-flex w-100" ngbDropdown data-live-search="true" #countriesMenu="ngbDropdown">
      <button
        [class.selector-is-invalid]="isFieldInvalid()"
        [disabled]="disableChangePhoneNumber"
        class="dropdown-btn btn select-border w-30"
        type="button"
        data-test-id="phone-number-countries-list-btn"
        ngbDropdownAnchor
        (click)="countriesMenu.isOpen() ? countriesMenu.close() : countriesMenu.open()"
      >
        {{ selectedCountryPhoneInfo.phoneCode }}
      </button>
      <input
        [class.is-invalid]="isFieldInvalid()"
        [ngClass]="fieldAttribute.elementStyles.contentStyle"
        [id]="fieldAttribute.id"
        [attr.data-test-id]="fieldAttribute.elementDataTestId"
        [placeholder]="replacePhoneNumberForPlaceholder()"
        [disabled]="disableChangePhoneNumber"
        maxlength="14"
        class="w-70 phone-number-input"
        (input)="onChanges($event.target.value)"
        [(ngModel)]="phoneNumber"
        type="text"
      />
      <ng-container *ngIf="hasValidValue() && !timerIsRunning">
        <button
          type="button"
          [attr.data-test-id]="'clear-button-' + fieldAttribute.elementDataTestId"
          class="btn btn-link clear-button"
          (click)="removeFieldValue()"
        >
          <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
        </button>
      </ng-container>
      <div class="countries-list w-100" ngbDropdownMenu aria-labelledby="dropdownManual">
        <input
          type="text"
          class="w-100 p-2 searchInput form-control"
          data-test-id="filter-dropdown-input-id"
          placeholder="{{ 'SEARCH_COUNTRY' | translate }}"
          [ngModel]="searchValue"
          (ngModelChange)="filterDropdown($event)"
        />
        <div *ngFor="let country of countries">
          <button
            type="button"
            class="d-flex"
            ngbDropdownItem
            [disabled]="country.isDisabled"
            (click)="onSelectedCountry(country)"
          >
            <div class="w-75p">{{ getPhoneCode(country) }}</div>
            <div class="w-100 w-s-break-spaces">{{ country.name }}</div>
          </button>
        </div>
        <div *ngIf="countries.length <= 0">&nbsp;{{ 'PHONE_NUMBER_SEARCH_NO_RESULT' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="phone-number-btn-container">
    <button
      *ngIf="showChangePhoneNumberBtn"
      class="btn btn-primary change-phone_number-btn"
      type="button"
      [attr.data-test-id]="'change-phone-number-btn'"
      (click)="changePhoneNumber()"
    >
      {{ phoneNumberBtnHint }}
    </button>
  </div>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
